import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white mt-12">
      <div className="container-main py-10">
        <div className="grid gap-8 sm:grid-cols-3">
          {/* Products */}
          <div className="text-sm">
            <div className="font-semibold text-slate-950">Products</div>
            <ul className="mt-3 space-y-2">
              <li><Link to="/" className="text-slate-600 hover:text-slate-900">Buyer's Report</Link></li>
              <li><Link to="/" className="text-slate-600 hover:text-slate-900">Seller's Pack</Link></li>
              <li><Link to="/pricing" className="text-slate-600 hover:text-slate-900">Pricing</Link></li>
              <li><Link to="/samples" className="text-slate-600 hover:text-slate-900">Sample reports</Link></li>
            </ul>
          </div>

          {/* Help */}
          <div className="text-sm">
            <div className="font-semibold text-slate-950">Help</div>
            <ul className="mt-3 space-y-2">
              <li><Link to="/how-it-works" className="text-slate-600 hover:text-slate-900">How it works</Link></li>
              <li><Link to="/faq" className="text-slate-600 hover:text-slate-900">FAQ</Link></li>
              <li><Link to="/contact" className="text-slate-600 hover:text-slate-900">Contact</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="text-sm">
            <div className="font-semibold text-slate-950">Legal</div>
            <ul className="mt-3 space-y-2">
              <li><Link to="/legal" className="text-slate-600 hover:text-slate-900">Legal & disclaimers</Link></li>
              <li><Link to="/legal#privacy" className="text-slate-600 hover:text-slate-900">Privacy</Link></li>
              <li><Link to="/legal#terms" className="text-slate-600 hover:text-slate-900">Terms</Link></li>
            </ul>
          </div>
        </div>

        {/* Single disclaimer line */}
        <div className="mt-10 pt-6 border-t border-slate-200 text-xs text-slate-600">
          Information and document preparation only. Not legal advice.
        </div>
      </div>
    </footer>
  );
}
